import { InquiryStepDefinition } from '../../types';
import { WeddingPartyQuestion } from './WeddingPartyQuestion';
import { WeddingPartySummary } from './WeddingPartySummary';

export const WEDDING_PARTY: InquiryStepDefinition = {
  stepName: 'WEDDING_PARTY',
  component: WeddingPartyQuestion,
  summaryComponent: WeddingPartySummary,
  isOptional: true,
  fieldNames: ['weddingPartyCount', 'stillDecidingOnWeddingParty', 'flexibleOnWeddingPartyCount'],
  tabIndex: 0,
  slug: 'wedding-party',
  isAnswered: () => true,
};
